import {
  createBrowserRouter,
  createRoutesFromElements,
  Route
} from 'react-router-dom'
import { LoadingScreen } from '@repo/ui'
import AcceptPrivacyPolicy from './features/settings/pages/AcceptPrivacyPolicy'
import ProtectedRoute from './features/settings/protection/protected-route'
import BfnDetails from './features/befehlsnachrichten/pages/BfnDetails'
import Layout from './components/layout'
import BfnOverview from './features/befehlsnachrichten/pages/BfnOverview'
import PageNotFound from './features/errors/pages/PageNotFound'
import FaqPage from './features/faq/pages/FaqPage'
import PrivacyPolicyPage from './features/legal/pages/PrivacyPolicyPage'
import Impressum from './features/legal/pages/Impressum'

export const Router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<Layout />}
      HydrateFallback={() => <LoadingScreen data-testid="router-loading" />}
    >
      <Route path="acceptPrivacyPolicy" element={<AcceptPrivacyPolicy />} />
      <Route element={<ProtectedRoute />}>
        <Route index element={<BfnOverview />} />
        <Route path="/befehlsnachrichten/:id" element={<BfnDetails />} />
      </Route>
      <Route path="faq" element={<FaqPage />} />
      <Route path="datenschutz" element={<PrivacyPolicyPage />} />
      <Route path="impressum" element={<Impressum />} />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  )
)
